'use client'
import React from 'react';
import { Suspense } from 'react';
import { AntdRegistry } from '@ant-design/nextjs-registry';
import './global.css'
import 'antd/dist/reset.css';
import AntConfigProvider from './home/component/AntConfigProvider';
import 'animate.css';
import Script from 'next/script';
export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {

  return (
    <html lang="en">
      <title>智能兔管家</title>
      {/* 禁止移动端缩放 */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
      {/* 禁止缓存 */}
      <meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta httpEquiv="Pragma" content="no-cache" />
      <meta httpEquiv="Expires" content="0" />
      {/* 引入微信 JS-SDK */}
      <Script
        src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"
        strategy="afterInteractive"
        onLoad={() => {
          console.log('微信 JS-SDK 已加载');
          // SDK加载完成后执行配置 
          // wx.config({  /* ... */ });
        }}
      />
      {/* <Script
        src="https://cdn.bootcdn.net/ajax/libs/vConsole/3.9.0/vconsole.min.js"
        strategy="afterInteractive"
        onLoad={() => {
          // @ts-ignore
          const vConsole = new VConsole();
        }}
      /> */}
      <body >
        <Suspense>
          <AntConfigProvider>
            <AntdRegistry>{children}</AntdRegistry>
          </AntConfigProvider>
        </Suspense>
      </body>
    </html>
  );
}
